<template>
  <div class="block-text-image">
    <div
      class="block-text-image__main"
      v-intro="$t('surveyNamespace.startVirtualTour')"
      v-intro-step="1"
    >
      <error-boundary
        v-show="errorAlert"
        v-on:alert-error-closed="(errorAlert = false), (errorMessage = '')"
        v-bind:errorMessage="errorMessage"
      ></error-boundary>
      <div v-if="loading" class="block-wizard__loading">
        <svg
          width="124"
          height="58"
          viewBox="0 0 124 58"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#0D93D2"
        >
          <g fill="none" fill-rule="evenodd">
            <g transform="translate(44 1)" stroke-width="2">
              <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
              <path d="M36 18c0-9.94-8.06-18-18-18">
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 18 18"
                  to="360 18 18"
                  dur="1s"
                  repeatCount="indefinite"
                />
              </path>
            </g>
          </g>
          <text
            font-family="Arial-BoldMT, Arial"
            font-size="12"
            font-weight="bold"
            fill="#302D2D"
            stroke="none"
          >
            <tspan x="0" y="54">{{ $t("surveyResult.loading") }}</tspan>
          </text>
        </svg>
      </div>
      <div v-else-if="!$lodash.isEmpty(surveySessionData)">
        <div
          class="t-page__head"
          v-intro="$t('surveyNamespace.introjsPage')"
          v-intro-step="2"
        >
          <div class="t-page__head-info large">
            <h1>
              {{
                $t("surveyResult.title", {
                  company: $lodash.get(YEnterpriseSectorUser, "data.Name"),
                })
              }}
            </h1>
            <template v-if="showEditDelay">
              <div class="c-message c-message--info">
                <span>Info</span>
                <p>{{ $t("surveyResult.editDelayMessage") }}</p>
                <button class="btn btn-transparent" type="button" @click="handleClose" aria-label="Close">
                  <svg class="icon icon-success" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 33 33">
                    <g transform="translate(1 1)">
                      <path d="M15.5,32C6.4,32-1,24.6-1,15.5C-1,6.4,6.4-1,15.5-1C24.6-1,32,6.4,32,15.5C32,24.6,24.6,32,15.5,32z M15.5,0
                        C6.95,0,0,6.95,0,15.5S6.95,31,15.5,31S31,24.05,31,15.5S24.05,0,15.5,0z"/>
                      <polygon points="21.15,21.85 15.15,15.86 9.15,21.85 8.45,21.15 14.44,15.15 8.45,9.15 9.15,8.45 15.15,14.44
                        21.15,8.45 21.85,9.15 15.86,15.15 21.85,21.15"/>
                    </g>
                  </svg>
                </button>
              </div>
            </template>
          </div>
        </div>
        <div class="t-page__body">
          <SurveyResultComponent
            :companyName="$lodash.get(YEnterpriseSectorUser, 'data.Name')"
            :surveyDateString="convertDate($lodash.get(YEnterpriseSectorUser, 'data.UpdatedAt'))"
            :comparisonCompanyName="$lodash.get(compareYEnterpriseSectorUser, 'data.Name')"
            :comparisonSurveyDateString="convertDate($lodash.get(compareYEnterpriseSectorUser, 'data.UpdatedAt'))"
            :reference="reference"
            :code="selectedCode"
            :category="selectedCategory"
            :surveySession="$lodash.get(surveySessionData, 'data')"
            :compareSurveySession="$lodash.get(compareSurveySessionData, 'data')"
          />

          <SurveyFiltersComponent
            class="survey-filter"
            :selectedCode="selectedCode"
            :mySectorCode="
              $lodash.get(YEnterpriseSectorUser, 'data.SectorCode')
            "
            :myProvince="
              $lodash.get(enterprise, 'Address.province')
                ? $lodash.get(enterprise, 'Address.province')
                : ''
            "
            :myEnterpriseSize="
              $lodash.get(surveySessionData, 'data.Category.Value')
            "
            :myTargetMarket="
              $lodash.get(surveySessionData, 'data.TargetMarket.Value')
            "
            :myExportation="
              $lodash.get(surveySessionData, 'data.Exportation.Value')
            "
            :mySite="$lodash.get(surveySessionData, 'data.Site.Value')"
            :selectedCategory="selectedCategory"
            v-on:selectfilter="selectFilter"
            v-on:clearfilter="clearFilter"
          />
          <!-- 2020 -->
          <template v-if="this.reference.Year === 2020">
            <!-- How to read results -->
            <div class="t-page__bottom-text">
              <p style="font-size: 18px">
                <strong>{{ $t("surveyResult.howToReadTitle") }}</strong>
              </p>
              <p>{{ $t("surveyResult.howToRead") }}</p>
            </div>

            <!-- References -->
            <ReferenceBox
              :querystringClean="querystringClean"
              :namespace="namespace"
              :token="token"
              :id="id">
            </ReferenceBox>

            <!-- Actions -->
            <div style="text-align: right">
              <a
                class="btn btn-alt print-hidden"
                style="text-align: left"
                v-on:click="playVirtualTour"
                >{{ $t("surveyNamespace.virtualTour") }}</a
              >
              <template v-if="!publicPage">
                <button
                  class="btn btn-alt print-hidden"
                  v-on:click="redirectToPrint"
                  v-intro="$t('surveyNamespace.introjsTelechargement')"
                  v-intro-step="9"
                >
                  {{ $t("surveyResult.download") }}
                </button>

                <div v-if="shareLinkCopied" class="share-link-copied">
                  {{ $t("surveyResult.shareLinkCopied") }}
                </div>
                <button
                  class="btn btn-alt print-hidden"
                  style="height: 50px"
                  v-else
                  v-intro="$t('surveyNamespace.introjsShareLink')"
                  v-intro-step="10"
                >
                  <span @click="copyShareLink" style="margin-right: 0.5em">{{
                    $t("surveyResult.share")
                  }}</span>
                  <input type="text" :value="shareLink" ref="shareRef" />
                </button>
              </template>
            </div>
          </template>

          <!-- 2022 -->
          <template v-else>
            <!-- Actions -->
            <div style="text-align: right">
              <a
                class="btn btn-alt print-hidden"
                style="text-align: left"
                v-on:click="playVirtualTour"
                >{{ $t("surveyNamespace.virtualTour") }}</a
              >
              <template v-if="!publicPage">
                <button
                  class="btn btn-alt print-hidden"
                  v-on:click="redirectToPrint"
                  v-intro="$t('surveyNamespace.introjsTelechargement')"
                  v-intro-step="9"
                >
                  {{ $t("surveyResult.download") }}
                </button>

                <div v-if="shareLinkCopied" class="share-link-copied">
                  {{ $t("surveyResult.shareLinkCopied") }}
                </div>
                <button
                  class="btn btn-alt print-hidden"
                  style="height: 50px"
                  v-else
                  v-intro="$t('surveyNamespace.introjsShareLink')"
                  v-intro-step="10"
                >
                  <span @click="copyShareLink" style="margin-right: 0.5em">{{
                    $t("surveyResult.share")
                  }}</span>
                  <input type="text" :value="shareLink" ref="shareRef" />
                </button>
              </template>
            </div>

            <!-- How to read -->
            <div class="t-page__bottom-text">
              <HowToRead2022></HowToRead2022>
            </div>

            <!-- References -->
            <ReferenceBox
              :querystringClean="querystringClean"
              :namespace="namespace"
              :token="token"
              :id="id">
            </ReferenceBox>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SurveyResultComponent from '@/components/SurveyResult.vue';
import SurveyFiltersComponent from '@/components/SurveyFilters.vue';
import HowToRead2022 from '@/components/HowToRead2022.vue';
import ReferenceBox from '@/components/ReferenceBox.vue';
import ErrorBoundary from '@/components/ErrorBoundary.vue';
import errorBoundary from '@/mixins/errorBoundary';
import { getYEnterpriseSectorUserByNamespace } from '@/providers/yEnterpriseSectorUsers';
import { format } from 'date-fns';

const _ = require('lodash');

/* eslint-disable no-console */
export default {
  name: 'SurveyNamespace',
  mixins: [errorBoundary],
  components: {
    SurveyResultComponent,
    SurveyFiltersComponent,
    ErrorBoundary,
    HowToRead2022,
    ReferenceBox,
  },
  async mounted() {
    this.urlResult = _.replace(
      window.location,
      window.location.origin,
      '',
    ).substr(1);
    const mongoObjectId = new RegExp('^[0-9a-fA-F]{24}$');
    this.querystring = _.get(this.$route, 'params.querystring');
    this.querystringClean = this.decodeUrl(this.querystring);
    this.referenceData = await this.getReferenceData();
    const sessionId = _.get(this.$route, 'params.sessionId');
    const compareSessionId = _.get(this.$route, 'params.compareSessionId');

    if (this.$route.name === 'SurveyNamespacePublic') {
      this.publicPage = true;
    }

    if (!this.publicPage) {
      this.token = await this.$auth.waitForToken();
    }

    // La QueryString n'est pas un identifiant MongoDB
    // On est dans le cas d'un retour de NetSurvey
    if (!mongoObjectId.test(this.querystringClean) && !this.publicPage) {
      this.isAuthenticated = await this.$auth.waitForSession();
      if (!this.isAuthenticated) {
        // L'utilisateur n'est pas authentifié
        // Retour maison
        this.$router.push({
          name: 'Home',
        });
      }
      this.showEditDelay = true;
      // Extraction des paramètres NetSurvey de la QueryString
      this.paramsUrl = this.getAllParamsFromUrl(this.querystringClean);
      this.loginFromNetSurvey = _.get(this.paramsUrl, 'LOG');

      this.YEnterpriseSectorUser = await getYEnterpriseSectorUserByNamespace(
        this.namespace,
        this.loginFromNetSurvey,
        _.get(this.paramsUrl, 'CT'),
      );
      this.id = _.get(this.YEnterpriseSectorUser, 'data._id');
      try {
        await Promise.all([
          (async () => {
            await this.getSurveySession();
          })(),
          (async () => {
            // Get enterprise info
            try {
              const response = await axios.get(
                `${process.env.VUE_APP_DIGISCORE_API}/enterprise/${_.get(
                  this.YEnterpriseSectorUser,
                  'data.EnterpriseNumber',
                )}`,
                {
                  headers: {
                    Authorization: `Bearer ${this.token}`,
                  },
                },
              );
              if (response && response.data) {
                this.enterprise = response.data;
              }
            } catch {
              return false;
            }
            return false;
          })(),
        ]);
        this.loading = false;
        if (!localStorage.getItem('introjsdone')) {
          setTimeout(() => {
            this.playVirtualTour();
          }, 250);
        }
      } catch (e) {
        console.log('ERREUR while create or update survey session');
        return false;
      }
    } else {
      this.surveySessionData = await axios.get(
        `${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUserSurveySession/${this.querystringClean}/${sessionId}`,
      );
      if (compareSessionId) {
        this.compareSurveySessionData = await axios.get(
          `${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUserSurveySession/${this.querystringClean}/${compareSessionId}`,
        );
        this.compareEnterprise = _.get(this.compareSurveySessionData, 'data.yEnterpriseSector');
        this.compareYEnterpriseSectorUser = { data: this.compareEnterprise };
      }
      this.enterprise = _.get(this.surveySessionData, 'data.yEnterpriseSector');
      this.YEnterpriseSectorUser = { data: this.enterprise };
      this.loading = false;
    }
    this.shareLink = `${window.location.origin}/survey-public/${
      this.namespace
    }/${_.get(this.YEnterpriseSectorUser.data, '_id')}/${_.get(this.surveySessionData.data, '_id')}`;
    return true;
  },
  data() {
    return {
      namespace: _.get(this.$route, 'params.namespace'),
      querystring: '',
      paramsUrl: {},
      loading: true,
      loginFromNetSurvey: '',
      isAuthenticated: false,
      YEnterpriseSectorUser: {},
      enterprise: {},
      referenceData: {},
      surveySessionData: {},
      compareSurveySessionData: null,
      compareEnterprise: null,
      compareYEnterpriseSectorUser: null,
      urlResult: '',
      selectedCode: undefined,
      selectedCategory: undefined,
      token: undefined,
      id: undefined,
      publicPage: false,
      showEditDelay: false,
      shareLink: '',
      shareLinkCopying: false,
      shareLinkCopied: false,
    };
  },
  methods: {
    playVirtualTour() {
      const intro = this.$intro();
      intro.setOptions({
        overlayOpacity: 0.25,
        prevLabel: this.$t('surveyNamespace.previous'),
        nextLabel: this.$t('surveyNamespace.next'),
        skipLabel: this.$t('surveyNamespace.jump'),
        doneLabel: this.$t('surveyNamespace.end'),
      });
      intro.start();
      localStorage.setItem('introjsdone', true);
      return true;
    },
    handleClose() {
      this.showEditDelay = false;
    },
    redirectToPrint() {
      const params = new URLSearchParams({
        ref: `${window.location.origin}/surveyPDF${this.compareSurveySessionData ? '-compare' : ''}/${_.get(
          this.$route,
          'params.namespace',
        )}/${
          _.get(this.YEnterpriseSectorUser, 'data._id')
        }/${
          _.get(this.surveySessionData, 'data._id')
        }${
          this.compareSurveySessionData ? `/${_.get(this.compareSurveySessionData, 'data._id')}` : ''
        }?token=${
          this.token
        }`,
        enterpriseName: _.get(this.surveySessionData, 'data.enterpriseName'),
      });
      window.open(
        `${process.env.VUE_APP_DIGISCORE_API}/pdf?${params.toString()}`,
        '_blank',
      );
    },
    decodeUrl(url) {
      let finalString = '';
      finalString = decodeURIComponent(url);
      finalString = finalString.replace(/&amp;/g, '&');
      finalString = finalString.replace(/&nbsp;/g, '');
      finalString = finalString.replace(/ /g, '');
      return finalString;
    },
    getAllParamsFromUrl(url) {
      const vars = url.split('&');
      const paramsArray = {};
      for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split('=');
        paramsArray[pair[0]] = decodeURIComponent(pair[1]);
      }
      return paramsArray;
    },
    controlCodeUrl(arr) {
      const formule = ((13 * parseInt(_.trim(_.get(arr, 'LOG').replace(/\D/, '')), 10))
          % 97)
        + 2;
      return _.isEqual(
        formule,
        parseInt(_.trim(_.get(arr, 'CT').replace(/\D/, '')), 10),
      );
    },
    constructSurveySessionObject(Namespace, YEnterpriseSectorUserId) {
      if (!Namespace) {
        this.displayError('retrieveSurveySessionResult', 'Namespace');
        throw new Error('Error retrieveSurveySessionResult : Namespace');
      }
      if (!YEnterpriseSectorUserId) {
        this.displayError(
          'retrieveSurveySessionResult',
          'YEnterpriseSectorUserId',
        );
        throw new Error(
          'Error retrieveSurveySessionResult : YEnterpriseSectorUserId',
        );
      }
      const surveySessionObject = {
        Namespace,
        YEnterpriseSectorUserId,
      };
      const surveySessionValues = [
        {
          name: 'LOG',
          description: this.$t('surveyResult.urlParameter.netsurveyLogin'),
          required: true,
        },
        {
          name: 'CT',
          description: this.$t('surveyResult.urlParameter.controlCode'),
          required: true,
        },
        {
          name: 'RH',
          description: this.$t('surveyResult.urlParameter.humanResourcesAxe'),
          required: true,
        },
        {
          name: 'IN',
          description: this.$t('surveyResult.urlParameter.infrastructureAxe'),
          required: true,
        },
        {
          name: 'PF',
          description: this.$t('surveyResult.urlParameter.processFlowAxe'),
          required: true,
        },
        {
          name: 'VP',
          description: this.$t('surveyResult.urlParameter.salesProductsAxe'),
          required: true,
        },
        {
          name: 'SIT',
          description: this.$t('surveyResult.urlParameter.siteDimension'),
          required: false,
        },
        {
          name: 'ZAE',
          description: this.$t(
            'surveyResult.urlParameter.activityAreaDimension',
          ),
          required: false,
        },
        {
          name: 'MAC',
          description: this.$t(
            'surveyResult.urlParameter.targetMarketDimension',
          ),
          required: false,
        },
        {
          name: 'EXP',
          description: this.$t(
            'surveyResult.urlParameter.exportationDimension',
          ),
          required: false,
        },
        {
          name: 'CTA',
          description: this.$t('surveyResult.urlParameter.categoryDimension'),
          required: false,
        },
      ];
      surveySessionValues.forEach((sessionValue) => {
        let parsedValue;
        const getUrlValue = _.get(this.paramsUrl, sessionValue.name);
        if (sessionValue.required && !getUrlValue) {
          this.displayError(
            'retrieveSurveySessionResult',
            sessionValue.description,
          );
          throw new Error(
            `Error retrieveSurveySessionResult : ${sessionValue.description}`,
          );
        } else if (sessionValue.required) {
          parsedValue = this.checkRequireValue(this.cleanUrlParam(getUrlValue));
          if (parsedValue === false) {
            this.displayError(
              'retrieveSurveySessionResult',
              sessionValue.description,
            );
            throw new Error(
              `Error retrieveSurveySessionResult : ${sessionValue.description}`,
            );
          }
        } else if (getUrlValue) {
          parsedValue = this.checkRequireValue(this.cleanUrlParam(getUrlValue));
        }
        if (parsedValue !== false) {
          _.set(surveySessionObject, _.get(sessionValue, 'name'), parsedValue);
        }
      });
      return surveySessionObject;
    },
    cleanUrlParam(param) {
      return Number.parseInt(_.trim(param.replace(/\D/, '')), 10);
    },
    checkRequireValue(param) {
      if (Number.isNaN(param)) {
        return false;
      }
      return param;
    },
    async getReferenceData(code = undefined, category = undefined) {
      let referenceDatauser = {};
      if (code === undefined || category === undefined) {
        try {
          referenceDatauser = await axios.get(
            `${process.env.VUE_APP_DIGISCORE_API}/referenceByNamespaceCategoryId/${this.namespace}/G/GLOB`,
          );
        } catch {
          return {};
        }
      } else {
        try {
          referenceDatauser = await axios.get(
            `${process.env.VUE_APP_DIGISCORE_API}/referenceByNamespaceCategoryId/${this.namespace}/${code}/${category}`,
          );
        } catch (e) {
          console.log('error', e);
          return {};
        }
      }
      return referenceDatauser;
    },
    async getSurveySession() {
      try {
        const token = await this.$auth.waitForToken();
        this.surveySessionData = await axios.get(
          `${
            process.env.VUE_APP_DIGISCORE_API
          }/yEnterpriseSectorUserSurveySession/${_.get(
            this.YEnterpriseSectorUser,
            'data._id',
          )}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
      } catch {
        return false;
      }
      return true;
    },
    async selectFilter(code, category) {
      this.selectedCode = code;
      this.selectedCategory = category;
      this.referenceData = await this.getReferenceData(code, category);
    },
    async clearFilter() {
      this.selectedCode = undefined;
      this.selectedCategory = undefined;
      this.referenceData = await this.getReferenceData();
    },
    copyShareLink() {
      this.shareLinkCopying = true;
      this.$nextTick(() => {
        this.$refs.shareRef.select();
        this.shareLinkCopied = document.execCommand('copy');
        this.shareLinkCopying = false;

        setTimeout(() => {
          this.shareLinkCopied = false;
        }, 5000);
      });
    },
    convertDate(d) {
      let date;
      if (d) {
        date = format(new Date(d), 'dd/MM/yyyy');
        return date;
      }
      return date;
    },
  },
  computed: {
    reference() {
      return this.$lodash.get(this.referenceData, 'data', {});
    },
  },
};
</script>

<style scoped>
.survey-filter {
  padding-top: 10px;
  padding-bottom: 20px;
}
.cta-inner {
  margin: 0;
}
.cta-inner h2 {
  font-size: 20px;
}
.cta-inner .btn-gradient {
  background: linear-gradient(
    194.57deg,
    #8bced0 0%,
    #0d93d2 47.92%,
    #0c7db3 100%
  );
  transition: 0.3s opacity cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.block-text-image__main {
  padding-top: 0;
}
.btn:disabled {
  color: lightgray;
  border-color: lightgray;
  cursor: not-allowed;
}
.share-link-copied {
  display: inline-block;
  color: #3b5e14;
  text-align: center;
  margin-top: 1.75em;
  min-width: 455px;
}
</style>
